import { render } from "./EnviarPropostaParcelamento.vue?vue&type=template&id=0095f9e0&scoped=true"
import script from "./EnviarPropostaParcelamento.vue?vue&type=script&lang=js"
export * from "./EnviarPropostaParcelamento.vue?vue&type=script&lang=js"

import "./EnviarPropostaParcelamento.vue?vue&type=style&index=0&id=0095f9e0&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0095f9e0"]])

export default __exports__